<template>
  <div class="menu-item-r">
    <div class="v-em-header font-size-16">
      <div class="v-nav-wrap">
        <el-button class="el-button--primary-empty" type="primary" size="small" v-if="subjectType === 'ACTOR'">{{
          $t('Favarite audience')
          }}</el-button>

        <el-button
          :class="{ 'el-button--primary': accType === 'exhibitor', 'el-button--primary-empty': accType !== 'exhibitor' }"
          type="primary" size="small" v-if="subjectType === 'VISITOR'" @click="switchFav('exhibitor')">
          {{ $t('Favarite exhibitor') }}
        </el-button>

        <el-button
          :class="{ 'el-button--primary': accType === 'product', 'el-button--primary-empty': accType !== 'product' }"
          type="primary" size="small" v-if="subjectType === 'VISITOR'" @click="switchFav('exhibit')">
          {{ $t('Favarite exhibit') }}
        </el-button>
      </div>
    </div>
    <!-- <div class="text-right m-b-12" style="margin-top: -18px;" v-if="subjectType == 'VISITOR'"><el-button type="primary"
        @click="dataExport" size="small">{{$t('Export')}}</el-button></div> -->
    <div v-if="this.accType == 'audience'">
      <div class="bl-find-list" v-loading="loading">
        <div class="bl-container">
          <el-row :gutter="30">
            <el-col :xs="8" :sm="8" :md="8" v-for="(item, index) in dataList" :key="item.id">
              <VisitorCard showType="collection" :vData="item" :index="index" @collect="collectEventPerson(item, index)"
                @invite="inviteEventPerson(item, index)" @details="detailsEventPerson(item, index)"
                @msg="msgEventPerson_a(item, index)" />
            </el-col>
          </el-row>
          <hNoData v-if="dataList.length == 0"></hNoData>
        </div>
        <div class="bl-container">
          <el-pagination v-if="dataList.length > 0" background @current-change="handleCurrentChange"
            :page-size="query.pageRows" :current-page.sync="query.pageNum" layout="total, prev, pager, next, jumper"
            :total="query.total" class="bl-page"></el-pagination>
        </div>
      </div>
    </div>
    <div v-if="this.accType == 'exhibitor'" class="v-exhibits-management-wrap">
      <div class="v-exhibits-management-list">
        <el-row :gutter="30">
          <el-col :span="8" v-for="(item, index) in exhibitors" :key="item.productId">
            <ExhibitorCard class="v-em-card" showType="collection" :slides="3" :index="index" :vData="item"
              @collect="collectEventExh(item, index)" @invite="inviteEventExh_a(item, index)"
              @details="detailsEventExh(item, index)" @msg="msgEventExh_a(item, index)"
              @live="liveEventExh(item, index)">
            </ExhibitorCard>
          </el-col>
        </el-row>
        <hNoData v-if="exhibitors.length == 0"></hNoData>
      </div>
      <div class="bl-container">
        <el-pagination background :hide-on-single-page="true" :page-size="exhPagination.pageSize"
          :current-page="exhPagination.currentPage" layout="total, prev, pager, next, jumper"
          :total="exhPagination.total" @current-change="goPageExh"></el-pagination>
      </div>
    </div>
    <div v-if="this.accType === 'product'" class="v-exhibits-management-wrap">
      <div class="v-exhibits-management-list">
        <el-row :gutter="30">
          <el-col :xs="6" :sm="6" :md="6" v-for="(item, index) in products" :index="index" :key="item.productId">
            <ExhibitCard :slides="5" class="v-em-card" :vData="item"
              @callback="callback({ type: 'details', data: item, index: index })">
              <div slot="exhibitsInfo" class="text-right theme-icon-color v-em-list">
                <div class="flex">
                  <div class="pointer zhibo-pointer" @click.stop="callback({ type: 'live', data: item, index })"
                    v-if="item['liveState']">
                    <span class="iconfont iconzhibo"></span>
                    <span class="font-size-12">{{liveStatusText(item.live)}}</span>
                  </div>
                  <div v-else></div>
                  <div class="font-size-14 v-pointer-view" v-if="item.pageView"><i
                      class="el-icon-view"></i>&nbsp;&nbsp;{{ item.pageView || 0 }}</div>
                </div>
              </div>
              <div slot="collect" v-if="$store.state.config.hideElement">
                <div class="font-size-13 text-right">
                  <div class="pointer v-pointer-collected"
                    @click.stop="callback({ type: 'collect', data: item, index: index })">
                    <span class="iconfont iconshoucang-xuanzhong theme-icon-color"></span><span>{{ $t('collect[0]')
                      }}</span>
                  </div>
                </div>
              </div>
              <div slot="footer" class="v-em-footer flex-end">
                <!-- <template v-if="$store.state.config.hideElement">
                  <div class="pointer" @click.stop="callback({ type: 'message', data: item, index: index })">
                    <span class="iconfont iconxiaoxi_weixuanzhong theme-icon-primary-color"></span>
                    <span>{{ $t('message') }}</span>
                  </div>
                  <div class="pointer disabled" v-if="item['invite']" @click.stop>
                    <span class="iconfont iconyaoyue theme-icon-primary-color"></span>
                    <span>{{ $t('finds.invited') }}</span>
                  </div>
                  <div class="pointer" v-else @click.stop="callback({ type: 'invite', data: item, index: index })">
                    <span class="iconfont iconyaoyue theme-icon-primary-color"></span>
                    <span>{{ $t('invite') }}</span>
                  </div>
                </template> -->
                <div class="pointer" @click.stop="callback({ type: 'details', data: item, index: index })">
                  <span class="el-icon-tickets theme-icon-primary-color"></span>
                  <span>{{ $t('details') }}</span>
                </div>
              </div>
            </ExhibitCard>
          </el-col>
        </el-row>
        <hNoData v-if="products.length == 0"></hNoData>
      </div>
      <div class="bl-container">
        <el-pagination background :hide-on-single-page="true" :page-size="pagination.pageSize"
          :current-page="pagination.currentPage" layout="total, prev, pager, next, jumper" :total="pagination.total"
          @current-change="goProductPage"></el-pagination>
      </div>
    </div>
    <ChatWithExhibitor @invite="submitInvite" :action="action" />
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import { getCollectionPersonList, getCollectionProductList, getCollectionActorList } from '@/api/collection'
import { exportExcelProduct, exportExcelActor } from '@/api/index'
import { eventMixin } from '@/mixins/event.js'
import { inviteMixin } from '@/mixins/inviteEvent.js'
import hNoData from '@/components/hNoData'
import ChatWithExhibitor from '@/components/chat/ChatWithExhibitor'
import VisitorCard from '@/components/card/VisitorCard'
import ExhibitCard from '@/components/card/ExhibitCard'
import ExhibitorCard from '@/components/card/ExhibitorCard'

export default {
  name: 'CollectionList',
  mixins: [eventMixin, inviteMixin],
  components: {
    ChatWithExhibitor,

    VisitorCard,
    hNoData,
    ExhibitCard,
    ExhibitorCard
  },
  data() {
    return {
      employeeList: [],
      to: '',
      action: 'chat',
      pagination: {
        pageSize: 12,
        total: 0,
        currentPage: 1
      },
      exhPagination: {
        pageSize: 9,
        total: 0,
        currentPage: 1
      },
      products: [],
      exhibitors: [],
      loading: false,
      query: {
        pageNum: 1,
        pageRows: 9,
        total: 0
      },
      dataList: [],
      accType: this.$route.params.type || 'audience'
    }
  },
  computed: {
    ...mapGetters(['exhibitorId', 'language', 'info', 'subjectType']),
    ...mapState(['exhibitorDialogVisible']),
    pages: function() {
      if (this.query.total == 0) return 0
      let y = this.query.total % this.query.pageRows
      if (y == 0) {
        return this.query.total / this.query.pageRows
      } else {
        return parseInt(this.query.total / this.query.pageRows) + 1
      }
    }
  },

  mounted() {
    this.fetchDataList()
  },

  methods: {
    // 导出
    dataExport() {
      let request = null
      if (this.accType == 'product') {
        request = exportExcelProduct()
      } else if (this.accType == 'exhibitor') {
        request = exportExcelActor()
      }
      request.then(res => {
        return res.data
      }).then(res => {
        if (res.data) {
          window.open(res.data, '_blank')
        }
      })
    },
    vExibitsCallback(eData) {
      this.liveEvent(eData.data.liveId)
    },
    // 切换收藏
    switchFav(type) {
      if (type === 'exhibitor' && this.accType !== 'exhibitor') {
        this.$router.push('/collection/exhibitor')
      }
      if (type === 'exhibit' && this.accType !== 'product') {
        this.$router.push('/collection/product')
      }
    },
    // 客商方法
    collectEventPerson(data) {
      // 取消收藏
      this.collectEvent({
        deleted: true, // 取消收藏
        collectionSubjectType: 'VISITOR', // 被收藏品身份（展商：ACTOR；展品：PRODUCT；客商：VISITOR）
        collectionSubjectId: data.id // 被收藏品ID
      }, () => {
        this.getPersonList()
      })
    },
    // 客商邀约
    inviteEventPerson(data, index) {
      let params = {
        projectId: this.info.projectId,
        userId: data.id
      }
      this.inviteEvent(params, index)
    },
    // 观众详情
    detailsEventPerson(data) {
      this.pageDetail(data, 'person')
    },
    // 观众消息方法
    msgEventPerson_a(data, index) {
      data.easemobAccount = data.imUserName
      if (!data.easemobAccount) {
        this.$notify.warning(this.$t('footprints.userAccountId'))
        return false
      }
      this.msgEventPerson(data, index)
    },
    // 展商 取消收藏
    collectEventExh(data) {
      // 取消收藏
      // TODO:  收藏记录ID不存在,API无法调用
      this.collectEvent({
        id: data.id, // 收藏记录id
        deleted: true, // 取消收藏
        collectionSubjectType: 'ACTOR', // 被收藏品身份（展商：ACTOR；展品：PRODUCT；客商：VISITOR）
        collectionSubjectId: data.actorId // 被收藏品ID
      }, () => {
        this.getExhList()
      })
    },
    // 展商邀约
    inviteEventExh_a(data, index) {
      data.exhibitorId = data.actorId
      data.exhibitorName = data.exhibitorName || data.name || data.atrName
      this.inviteEventExh(data, index, 'exhibitors')
    },
    // 展商详情
    detailsEventExh(data) {
      this.pageDetail(data, 'actor')
    },
    // 展商消息
    msgEventExh_a(data) {
      data.exhibitorId = data.actorId || data.id
      data.atrName = data.atrName || data.exhibitorName || data.name
      this.msgEventExh(data, null, 'exhibitors')
    },
    // 直播方法
    liveEventExh(data) {
      this.liveEvent(data.liveId)
    },

    // 展品方法
    callback(res) {
      if (res.type === 'collect') {
        this.collectEvent({
          id: res.data.id,
          deleted: true,
          collectionSubjectType: 'PRODUCT',
          collectionSubjectId: res.data.productId
        }, () => {
          this.getProductList()
        })
      } else if (res.type == 'message') {
        // 消息
        let data = res.data
        data.exhibitorId = data.actorId
        data.atrName = data.exhibitorName
        this.msgEventExh(data, null, 'products')
      } else if (res.type == 'invite') {
        // 邀约
        let data = res.data
        data.exhibitorId = data.actorId
        this.inviteEventExh(data, res.index, 'products')
      } else if (res.type == 'details') {
        // 详情
        if (res.data.scope == 1 && res.data.inPool == false) {
          this.$alert(this.$t('common.productTipsContent'), this.$t('common.productTipsTitle'), {
            confirmButtonText: this.$t('common.ok')
          }).then(() => {
            this.$router.push(`/find-exhibitor/detail/${res.data.actorId}`)
          })
          return
        }
        this.pageDetail(res.data, 'product')
      } else if (res.type == 'live') {
        // 直播
        this.liveEvent(res.data.liveId)
      }
    },

    // 更新邀约状态
    updateInvite(status, index, type='dataList') {
      this[type][index]['invite'] = status
    },
    // 客商页码 change
    handleCurrentChange(page) {
      this.query.pageNum = page
      this.getPersonList()
    },
    // 获取列表
    fetchDataList() {
      if (this.accType === 'audience') {
        this.getPersonList()
      } else if (this.accType === 'product') {
        this.getProductList()
      } else if (this.accType === 'exhibitor') {
        this.getExhList()
      }
    },
    // 获取客商列表
    getPersonList() {
      this.loading = true
      getCollectionPersonList({
        pageRows: this.query.pageRows,
        pageNum: this.query.pageNum,
        exhibitorId: this.exhibitorId,
        showType: 'VISITOR'
      })
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000) {
            let data = res.data
            this.query.total = data.total || 0
            this.query.pages = data.pages || 0
            this.dataList = data.list || []
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 获取展商列表
    getExhList() {
      this.loading = true
      getCollectionActorList({
        pageRows: this.exhPagination.pageSize,
        pageNum: this.exhPagination.currentPage,
        exhibitorId: this.exhibitorId,
        showType: 'ACTOR'
      })
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000) {
            this.exhPagination.total = res.data.total || 0
            this.exhPagination.currentPage = res.data.pageNum || 0
            this.exhibitors = res.data.list || []
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 获取展品列表
    getProductList() {
      this.loading = true
      getCollectionProductList({
        pageRows: this.pagination.pageSize,
        pageNum: this.pagination.currentPage,
        exhibitorId: this.exhibitorId,
        showType: 'PRODUCT'
      })
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000) {
            this.pagination.total = res.data.total
            this.pagination.currentPage = res.data.pageNum
            this.products = res.data.list
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 展品页码 change
    goProductPage(val) {
      this.pagination.currentPage = val
      this.getProductList()
    },
    // 展商页码 change
    goPageExh(val) {
      this.exhPagination.currentPage = val
      this.getExhList()
    }
  }
}
</script>

<style lang="stylus" scoped>
.v-em-footer {
  & > .pointer {
    margin-left: 8px!important;
  }

  & > .pointer:first-child{
    margin-left: 0!important;
  }
}

.bl-find-list
  padding-bottom 30px
.v-nav-wrap
  width 100%
  max-width $container-width
  margin 0 auto
  padding-left 15px
  padding-right 15px
.v-exhibits-management-wrap
  max-width $container-width
  margin 0 auto
  padding 0 15px 40px 15px
  padding-right: 0px;
  .v-em-header
    // padding:40px 0;
    >div
      margin-right 24px
    .el-select
      margin-left 12px
    .v-audit-status-1
      color $color-main
      margin-left 4px
    .v-audit-status-2
      color $color-blue-50
      margin-left 4px
    .v-audit-status-3
      color $color-red-f5
      margin-left 4px
  .v-exhibits-management-list
    flex-wrap wrap
    .v-em-card
      margin 0 15px 25px 0
      &:nth-child(3n+0)
        margin-right 0

  .v-em-list
    padding 8px 8px
  .v-em-footer
    >div
      margin-left 15px
  .el-pagination
    text-align right
</style>
